export default "__VITE_ASSET__cPEwggxt__"